import Http from "../http";

// SAM-257: the writes below return `{ success: false, data: null }` on
// failure rather than a truthy `[]`. asset.controller.ts replies
// `{ success: true }` on rotate, delete and replace. Reads keep `[]`/`null`.

export const downloadAllFiles = async (params) => {
  const path = `/v2/asset/zip`;

  try {
    const response = await Http.sharedInstance
      .withAuth()
      .get(path, { params, responseType: "blob" });
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = "assets.zip";
    link.href = URL.createObjectURL(
      new Blob([response.data], { type: "application/zip" })
    );
    link.click();
    return response.blob();
  } catch (e) {
    return null;
  }
};

export const getFilesList = async (params) => {
  const path = `/v2/asset`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path, {
      params: params,
    });
    return response.data;
  } catch (e) {
    return [];
  }
};

export const deleteFiles = async (id) => {
  const path = `/v2/asset/${id}`;
  try {
    const response = await Http.sharedInstance.withAuth().delete(path);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const replaceFiles = async (params) => {
  const path = `/v2/asset/${params.targetId}/${params.sourceId}`;
  try {
    const response = await Http.sharedInstance.withAuth().patch(path);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const rotateFile = async ({ id, rotation }) => {
  const path = `/v2/asset/${id}/rotate`;
  try {
    const response = await Http.sharedInstance.withAuth().post(path, {
      rotation,
    });
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};
